import { useCallback } from 'react';
import { Box } from '@mui/material';

import { BackButtonComponent } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButtonComponent';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { useGetNavigationActions } from '@ocx-app/hooks/useGetNavigationActions';
import { NavigationBar, Page, PageContent, ScreenLoaderBackdrop } from '@ocx/ui';

import { spireMessages } from './spire.messages';

export type SpireLayoutProps = {
  children: React.ReactNode;
  isLoading?: boolean;
};

export const SpireLayout = ({ children, isLoading }: SpireLayoutProps) => {
  const { pushToHome } = useGetNavigationActions();

  const handleClose = useCallback(() => {
    pushToHome();
  }, [pushToHome]);

  return (
    <Page>
      <HtmlTitle title={spireMessages.htmlTitle} />
      <NavigationBar left={<BackButtonComponent onClick={handleClose} type="close" />} center={<VendorLogo />} />
      <PageContent>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
          }}>
          {children}
        </Box>
        {isLoading && <ScreenLoaderBackdrop open />}
      </PageContent>
    </Page>
  );
};
